import ComponentModule from "@eisinc/Overrides/Components/NavigationDrawer";

export * from "@eisinc/Overrides/Components/NavigationDrawer";

export default ComponentModule;
